import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./vp7200.css";

function AP6800() {
    const [mainImage, setMainImage] = useState("/images/6800/2-1.png");
    const [activeTab, setActiveTab] = useState("features");

    const thumbnails = [
        "/images/6800/2-2.png",
        "/images/6800/2-3.png",
        "/images/6800/2-4.png",
        "/images/6800/2-5.png",
        "/images/6800/2-6.png",
    ];
    return (
        <>
            <Header />
            <section className="vp7200-container">

                {/* LEFT SIDE */}
                <div className="vp7200-left">
                    <div className="main-image">
                        <img src={mainImage} alt="AP6800" />
                    </div>

                    {/* <div className="thumbnails">
            {thumbnails.map((img, index) => (
              <img
                key={index}
                src={img}
                alt=""
                onClick={() => setMainImage(img)}
              />
            ))}
          </div> */}
                    <div className="thumbnails">

                        {/* TOP ROW (2 IMAGES) */}
                        <div className="thumb-row top-row">
                            {thumbnails.slice(0, 3).map((img, index) => (
                                <img
                                    key={index}
                                    src={img}
                                    alt=""
                                    onClick={() => setMainImage(img)}
                                />
                            ))}
                        </div>

                        {/* BOTTOM ROW (3 IMAGES) */}
                        <div className="thumb-row bottom-row">
                            {thumbnails.slice(3, 5).map((img, index) => (
                                <img
                                    key={index}
                                    src={img}
                                    alt=""
                                    onClick={() => setMainImage(img)}
                                />
                            ))}
                        </div>

                    </div>
                </div>

                {/* RIGHT SIDE */}
                <div className="vp7200-right">

                    {/* TOP CONTENT */}
                    <div className="content-top">
                        <h1>AP6800</h1>
                        <h3>Secure Contactless Payment Reader with Camera</h3>

                        <p>
                            The AP6800 is an advanced <b>all-in-one unattended smart payment terminal</b> designed for self-service environments that need more than simple payment acceptance.
                        </p>

                        <p>
                            Built on Android 13, it combines secure unattended payments with application hosting, touchscreen interaction and rich multimedia capability, making it an ideal choice for vending, parking, self-order kiosks and other high-engagement self-service environments.
                        </p>
                    </div>

                    {/* TABS */}
                    <div className="tabs">
                        <button
                            className={activeTab === "features" ? "active" : ""}
                            onClick={() => setActiveTab("features")}
                        >
                            KEY FEATURES
                        </button>

                        <button
                            className={activeTab === "specs" ? "active" : ""}
                            onClick={() => setActiveTab("specs")}
                        >
                            SPECIFICATIONS
                        </button>
                    </div>

                    {/* TAB CONTENT */}
                    <div className="tab-content">
                        {activeTab === "features" && (
                            <ul>
                                <li>Android 13 platform with upgradeable architecture</li>
                                <li>PCI 6.X SRED secure unattended payment terminal</li>
                                <li>5" capacitive touchscreen with PIN-on-Glass</li>
                                <li>Hosts and runs payment and self-order applications</li>
                                <li>Can drive an external display up to 4K resolution</li>
                                <li>Ideal for videos, promotions, customer guidance and advertising</li>
                                <li>Supports remote device management for easier estate control</li>
                                <li>Built for unattended self-service environments</li>
                                <li>Rugged design with IP65 and IK08 ratings</li>
                                <li>Suitable for demanding indoor and outdoor use</li>
                            </ul>
                        )}

                        {activeTab === "specs" && (
                            <ul>
                                <li>Connectivity: USB-C, Ethernet, LTE</li>
                                <li>Operating Temp: -30°C to 70°C</li>
                                <li>Security: PCI PTS 6.x</li>
                                <li>Ingress Protection: IP65</li>
                                <li>Dimensions: Compact form factor</li>
                            </ul>
                        )}
                    </div>
                </div>
            </section>
            <section className="vp7200-benefits">

                <div className="vp7200-benefits-container">

                    {/* LEFT CONTENT */}
                    <div className="benefits-left">
                        <h2>Built for high-demand environments</h2>

                        <p>
                            Beyond Payments - A smarter self-service experience
                            Powerful, interactive, and built for modern unattended environments.
                        </p>

                        <ul>
                            <li>Offers a premium self-service experience with a 5" touchscreen and intuitive customer interaction</li>
                            <li>Run more than just payments - host apps, self-ordering, and mutimedia directly on the device</li>
                            <li>Built to last with rugged IP65 and IK08 protection for reliable indoor and outdoor performance</li>
                            <li>Stay secure with PCI 6.X SRED compliance for trusted unattended payments</li>
                            <li>Flexible and future-ready with multiple connectivity options and external display support</li>
                        </ul>

                        {/* PAYMENT METHODS */}
                        <h3 className="payment-title">Multiple Payment Methods</h3>

                        <div className="payment-logos">
                            <img src="/images/7200/gpay.png" alt="GPay" />
                            <img src="/images/7200/mc.png" alt="Mastercard" />
                            <img src="/images/7200/amex.png" alt="Amex" />
                            <img src="/images/7200/visa.png" alt="Visa" />
                            <img src="/images/7200/apple.png" alt="Apple Pay" />
                            <img src="/images/7200/samsung.png" alt="Samsung Pay" />
                            <img src="/images/7200/alipay.png" alt="Alipay" />
                        </div>
                    </div>

                    {/* RIGHT IMAGE */}
                    <div className="benefits-right">
                        <img
                            src="/images/6800/2-7.png"
                            alt="Kiosk"
                        />
                    </div>
                </div>
            </section>
            <section className="vp7200-features">
                <div className="vp7200-features-container">
                    <div className="feature-item">
                        <img src="/images/7200/flex-connect.png" alt="Connectivity" />
                        <h4>Flexible Connectivity</h4>
                        <p>Integrate seamlessly into your existing infrastructure.</p>
                    </div>

                    <div className="feature-item">
                        <img src="/images/7200/secure.png" alt="Security" />
                        <h4>Secure & Compliant</h4>
                        <p>Protect your business and customers with advanced security.</p>
                    </div>

                    <div className="feature-item">
                        <img src="/images/7200/rugged.png" alt="Rugged" />
                        <h4>Rugged & Reliable</h4>
                        <p>Built to withstand tough environments and 24/7 use.</p>
                    </div>

                    <div className="feature-item">
                        <img src="/images/7200/cust.png" alt="Customer" />
                        <h4>Customer Engagement</h4>
                        <p>Enhance the payment experience and drive loyalty.</p>
                    </div>
                </div>
            </section>
            <section className="vp7200-specs">

                <div className="vp7200-specs-container">

                    <h2 className="specs-title">Technical Specifications</h2>

                    {/* ELECTRICAL */}
                    <div className="spec-group">
                        <div className="spec-label">ELECTRICAL</div>

                        <div className="spec-content electrical">
                            <div className="spec-row">
                                <span>OPERATING SYSTEM</span>
                                <p>ANDROID 13 (UPGRADEABLE)</p>
                            </div>

                            <div className="spec-row">
                                <span>CERTIFICATION</span>
                                <p>PCI 6.X SRED</p>
                            </div>

                            <div className="spec-row">
                                <span>POWER SUPPLY</span>
                                <p>TDES 112, AED 128, SALTED HASH, TRANSARMOR, RETAIL MAC SUPPORT</p>
                            </div>

                            <div className="spec-row">
                                <span>KEY MANAGEMENT</span>
                                <p>AES DUKPT, TDES DUKPT, TRANSARMOR RSA & TDES</p>
                            </div>

                            <div className="spec-row">
                                <span>POWER</span>
                                <p>9V/3A</p>
                            </div>

                            <div className="spec-row">
                                <span>POWER CONSUMPTION</span>
                                <p>13.5W (W/OUT 2ND DISPLAY)</p>
                            </div>
                        </div>
                    </div>

                    {/* ENVIRONMENTAL */}
                    <div className="spec-group">
                        <div className="spec-label">ENVIRONMENTAL</div>

                        <div className="spec-content environmental">
                            <div className="spec-row">
                                <span>IMPACT RATING</span>
                                <p>IK08</p>
                            </div>

                            <div className="spec-row">
                                <span>INGRESS PROTECTION RATING</span>
                                <p>IP65</p>
                            </div>

                            <div className="spec-row">
                                <span>OPERATING ENVIRONMENT</span>
                                <p>WATER RESISTANT FOR INDOOR & OUTDOOR USE</p>
                            </div>

                            <div className="spec-row">
                                <span>OPERATING TEMPERATURE</span>
                                <p>-30°C TO 70°C (MAX CHANGE OF 10°C PER/HOUR)</p>
                            </div>

                            <div className="spec-row">
                                <span>STORAGE TEMPERATURE</span>
                                <p>-30°C TO 85°C (NON-CONDENSING)</p>
                            </div>
                        </div>
                    </div>

                    {/* MECHANICAL */}
                    <div className="spec-group">
                        <div className="spec-label">MECHANICAL</div>

                        <div className="spec-content mechanical">
                            <div className="spec-row">
                                <span>DIMENSIONS</span>
                                <p>EXTERNAL: 150MM X 100MM X 30MM</p>
                            </div>
                            <div className="spec-row">
                                <span></span>
                                <p>ENVELOPMENT: 150MM X 100MM X 55 MM (W/FAN)</p>
                            </div>

                            <div className="spec-row">
                                <span>MEMORY</span>
                                <p>4GB LPDR4, 16GB EMMC FLASH</p>
                            </div>

                            <div className="spec-row">
                                <span>DISPLAY</span>
                                <p>5"TFT CAPACITIVE TOUCH PANEL WITH 800 X 480 RESOLUTION</p>
                            </div>

                            <div className="spec-row">
                                <span>FRONT FACING CAMERA</span>
                                <p>5 MEGAPIXEL WITH AUTO FOCUS & PROXIMITY SENSOR</p>
                            </div>

                            <div className="spec-row">
                                <span>BARCODE CAMERA</span>
                                <p>2M MEGAPIXEL FOR BARCODE & QR SCANNING</p>
                            </div>

                            <div className="spec-row">
                                <span>SAMS</span>
                                <p>4 SAMS (3 SAMS WITH LTE OPTION)</p>
                            </div>

                            <div className="spec-row">
                                <span>SD CARD SLOT</span>
                                <p>1 SLOT</p>
                            </div>

                            <div className="spec-row">
                                <span>AUDIO</span>
                                <p>AUDIO WITH INTERNAL SPEAKER & AUDIO LINE OUT THROUGH MULIIPORT USB-C PORT</p>
                            </div>

                            <div className="spec-row">
                                <span>INTERFACE</span>
                                <p>DUAL USB, RS232, ETHERNET, DUAL BAND WI-FI, BLUETOOTH, LTE 4G CAT4</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default AP6800;